import { Directive, HostBinding, Input } from '@angular/core';
import { ObjectTypes } from '../../types/object-type';
import { ISiteMapContentItem } from '@fi-shared/models/site-map';
import { IWidgetSettingsModel } from '@fi-shared/widget/widget-settings.model';
import { SiteMapHelperService } from '@fi-shared/fi-shared-services/site-map-helper.service';

@Directive()
export abstract class WidgetContentSitemapChildItemsComponentBase {
    @Input() parentItem: ISiteMapContentItem;
    @Input() siteMapSettings: IWidgetSettingsModel;

    constructor(protected siteMapHelperService: SiteMapHelperService) {}

    @HostBinding('class.fi-widget-content-sitemap-child-items') _class: boolean = true;
    isShowChildItem(item: ISiteMapContentItem): boolean {
        let result = item.ObjectType !== ObjectTypes.MediaBank || this.siteMapSettings.displayFiles === true;

        if (result && item.ObjectType === ObjectTypes.Tag) {
            // hide tag if user has no view access to all its children and tag does not contain subtags
            // https://chainformation.atlassian.net/browse/FI-5480
            const childTags = item.ChildItems.filter((childItem) => childItem.ObjectType === ObjectTypes.Tag);
            if (!childTags.length) {
                const itemsWithViewAccess = item.ChildItems.filter(
                    (childItem) => childItem.ObjectType !== ObjectTypes.Tag && childItem.HasViewAccess,
                );
                if (!itemsWithViewAccess.length) {
                    result = false;
                }
            }
        }
        return result;
    }

    isShowMediaDivider(item: ISiteMapContentItem, $index: number): boolean {
        return (
            item.ObjectType === ObjectTypes.MediaBank &&
            this.parentItem.ChildItems[$index - 1] &&
            this.parentItem.ChildItems[$index - 1].ObjectType !== ObjectTypes.MediaBank
        );
    }

    isShowSubHeader(item: ISiteMapContentItem): boolean {
        return item.ObjectType === ObjectTypes.Tag;
    }

    isHasViewAccess(item: ISiteMapContentItem) {
        return item.ObjectType !== ObjectTypes.Tag && item.HasViewAccess;
    }

    getChildName(item: ISiteMapContentItem) {
        if (
            this.siteMapSettings.displayNumbering !== true ||
            // media files shouldn't be numbered (FI-940 AC 3)
            item.ObjectType === ObjectTypes.MediaBank
        ) {
            return item.Name;
        }

        return item.NamePrefix + ' ' + item.Name;
    }

    getBackgroundImage(item: ISiteMapContentItem) {
        return this.siteMapHelperService.getBackgroundImage(item);
    }

    isHighlightAsUnread(item: ISiteMapContentItem) {
        return !item.IsVisited && this.siteMapSettings.indicateUnreadItems;
    }
}
